import { useCustomSettings, useCustomCSS } from './useCustomSettings'

/**
 * Hook that provides access to all partner customization features.
 * Combines the functionality of useCustomSettings and useCustomCSS.
 */
export const usePartnerCustomization = () => {
	const {
		data: customSettings,
		isLoading: isLoadingSettings,
		isError: isSettingsError,
	} = useCustomSettings()

	const {
		data: customCSS,
		isLoading: isLoadingCSS,
		isError: isCSSError,
	} = useCustomCSS()

	return {
		// Custom settings
		customSettings,
		isLoadingSettings,
		isSettingsError,

		// Custom images
		images: customSettings?.images,
		sidebarLogo: customSettings?.images?.sidebar_logo,
		loginLogo: customSettings?.images?.login_logo,
		loginBackground: customSettings?.images?.login_bg,
		favicon: customSettings?.images?.favicon,

		// Partner name
		partnerName:
			customSettings?.name || (import.meta.env.VITE_COMPANY_NAME as string),

		// Custom CSS
		customCSS,
		isLoadingCSS,
		isCSSError,

		// Overall loading state
		isLoading: isLoadingSettings || isLoadingCSS,

		// Overall error state
		hasError: isSettingsError || isCSSError,

		// Helper methods
		hasCustomization: !!(
			customSettings?.images?.sidebar_logo ||
			customSettings?.images?.login_logo ||
			customSettings?.images?.login_bg ||
			customSettings?.images?.favicon ||
			customCSS
		),
	}
}

export default usePartnerCustomization
